import { CountByStatusMetadata, paginated, routesBuilder } from '@guiker/api-definition'

import { Booking, BookingStatus } from '../../entity'
import { paths } from './paths'
import {
  addUnitManagerPayloadSchema,
  readAllBookingsForPropertyOwnerQueryParamsSchema,
  readAllBookingsQueryParamsSchema,
  readAllBookingsWithListingIdsQueryParamsSchema,
  replaceListingUnitPayloadSchema,
  setEarlyTerminationSchema,
  updateBookingInfoSchema,
} from './schema'

const BOOKING_WITH_ID_PATH = paths.booking.one.withId(':bookingId')

const base = routesBuilder<Booking>()({ basePath: paths.booking.one.base() })
const idNested = routesBuilder<Booking>()({ basePath: BOOKING_WITH_ID_PATH })
const token = routesBuilder<string>()({ basePath: `${BOOKING_WITH_ID_PATH}/generate-access-token` })

export const routes = {
  readOneBooking: idNested.buildGet({}),
  readAllBookings: base.buildGet({
    paginated,
    path: `${paths.booking.all.base()}/search`,
    queryParamsSchema: readAllBookingsQueryParamsSchema,
    additionalMeta: {} as CountByStatusMetadata<BookingStatus>,
  }),
  readAllBookingsForPropertyOwner: base.buildGet({
    paginated,
    path: `${paths.booking.all.base()}/property-owner`,
    queryParamsSchema: readAllBookingsForPropertyOwnerQueryParamsSchema,
    additionalMeta: {} as CountByStatusMetadata<BookingStatus>,
  }),
  readAllActiveBookingsWithListingIds: base.buildGet({
    responseIsArray: true,
    path: `${paths.booking.all.base()}/with-listing-ids`,
    queryParamsSchema: readAllBookingsWithListingIdsQueryParamsSchema,
  }),
  voidConfirmedBooking: idNested.buildPut({
    path: '/void',
  }),
  updateBookingInfo: idNested.buildPut({
    path: '/update-info',
    payloadSchema: updateBookingInfoSchema,
  }),
  changeLeaseTerm: idNested.buildPut({
    path: '/change-lease-term',
    payloadSchema: setEarlyTerminationSchema,
  }),
  addUnitManager: idNested.buildPost({
    path: '/invite',
    payloadSchema: addUnitManagerPayloadSchema,
  }),
  replaceListingUnit: idNested.buildPut({
    path: '/replace-listing-unit',
    payloadSchema: replaceListingUnitPayloadSchema,
  }),
  generateAccessControlToken: token.buildGet({}),
}
